import { createSlice } from '@reduxjs/toolkit';
import { Slices } from 'ducks/slices';
import { ProjectParameters } from 'ducks/types/store-types';
import { NullableNumberInterface, UnionFromArray } from 'ducks/types/type-helpers';

export type ParameterState = NullableNumberInterface<UnionFromArray<ProjectParameters>>;

const initialState: ParameterState = {
  parameter_name: '',
  parameter_direction_id: 1,
  description: '',
  parameter_method_id: 1,
  parameter_method_name: 'Command Line',
  is_required: false,
  parameter_value: '',
  command_line_assignment_char: '=',
  command_line_escaped: true,
  command_line_ignore_name: false,
  command_line_prefix: '--',
  is_encrypted: false,
  reference_type_id: null,
  reference_id: null,
  reference_parameter_name: '',
  owner_id: null,
  parameter_direction_name: '',
  reference_type_name: '',
  reference_name: '',
  modified: false,
  saved: false,
  delete: false,
  parameter_value_disabled: false,
  uuid: '',
};

const parameterSlice = createSlice({
  name: Slices.PARAMETER,
  initialState,
  reducers: {
    setParameter: (_, action) => {
      return action.payload;
    },
    clearParameter: () => {
      return initialState;
    },
  },
});

export const { setParameter, clearParameter } = parameterSlice.actions;

export default parameterSlice.reducer;
